export default __webpack_public_path__ + "static/media/03.43edf393.png";